import { BrandTypes } from './actionTypes';

const initialState = {};

const brand = (state = initialState, action: any) => {
  switch (action.type) {
    case BrandTypes.GET_BRAND:
      state = { ...state, ...action.payload };
      break;
    case BrandTypes.GET_BRAND_SUCCESS:
      state = { ...state, ...action.payload };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default brand;
